import Vue from 'vue';
import { ActionTree } from 'vuex';
import * as types from './types';
import api from '@mail/api'


export default <ActionTree<mail.state.MailState, RootState>>{
    [types.EMAIL_CURRENT](action, selection: mail.EmailSelectionInfo) {
        if (selection.email?.isRead == 'False') {
            api.mail.changeReadState(selection.id, true)
        }
        action.commit(types.EMAIL_CURRENT, selection);
    },

    [types.EMAIL_DETAIL](action, id: string): Promise<mail.EmailMessage> {
        if (!id && typeof id !== 'string') {
            throw Error('The ID parameter value only accepts string.');
        }
        return api.mail.getDetail(id).then((email) => {
            // if (
            //     // popup인 경우 currentEmail이 null
            //     !action.state.currentEmail ||
            //     // 상세 내용을 조회 하는 중 다른 아이템을 클릭할 경우 무시
            //     action.state.currentEmail?.id === email.id
            // ) {
                action.dispatch(types.EMAIL_CURRENT, {
                    id: id,
                    method: 'none',
                    email: email,
                } as mail.EmailSelectionInfo);
            //}
            return email;
        });
    },

    [types.FOLDER_LOAD](action, parentId?: string) {
        return api.folder.getFolderTree(parentId).then((folders) => {
            action.commit(types.FOLDER_LOAD, {
                parentId: parentId,
                listData: folders,
            });
        });
    },
}
